import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../utils/fbPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  fullWidth = false,
  href = '#pricing'
}: CTAButtonProps) {
  const handleClick = () => {
    // Fire AddToCart pixel event for external (Shopify) links
    if (href && !href.startsWith('#')) {
      trackAddToCart({
        content_name: 'Ritual de Cierre Nocturno',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    if (onClick) {
      onClick();
    } else if (href) {
      if (href.startsWith('#')) {
        document.querySelector(href)?.scrollIntoView({
          behavior: 'smooth'
        });
      } else {
        window.location.href = href;
      }
    }
  };
  return <motion.button whileHover={{
    scale: 1.02,
    boxShadow: '0 0 20px rgba(201, 149, 107, 0.4)'
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative overflow-hidden group
        bg-[#c9956b] text-[#0c1220] 
        font-semibold text-lg py-4 px-8 rounded-lg
        shadow-[0_0_15px_rgba(201,149,107,0.2)]
        transition-all duration-300 ease-out
        flex items-center justify-center gap-2
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} onClick={handleClick} data-id="element-1">
      <span className="relative z-10 font-bold tracking-wide" data-id="element-2">{children}</span>
      <ArrowRight className="w-5 h-5 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-3" />

      {/* Inner glow effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-shimmer" data-id="element-4" />
    </motion.button>;
}